import type { Ref } from 'vue';
import { computed } from 'vue';
import { getLiveScoreMarketGroup } from '@/core/lib/betBuilderHelper';
import { formatLiveScore } from '@/core/oddsApi/helpers/liveScore';
import type { IBetBuilderLeg } from '@/interface/betBuilder';

export function useBetBuilderLegLiveScore(leg: Ref<IBetBuilderLeg>) {
    const liveScoreDisplay = computed(() => {
        if (!leg.value.isLive) {
            return null;
        }

        if (getLiveScoreMarketGroup(leg.value.marketType.id) === null) {
            return null;
        }

        const legScore = leg.value.betLiveScore;
        return legScore
            ? formatLiveScore(legScore.home, legScore.away, ':')
            : null;
    });

    return {
        liveScoreDisplay,
    };
}
